import { render, staticRenderFns } from "./AdministrationView.vue?vue&type=template&id=7f61887a&scoped=true&"
import script from "./AdministrationView.vue?vue&type=script&lang=js&"
export * from "./AdministrationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f61887a",
  null
  
)

export default component.exports